import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '../Dropdown';
import * as S from './BookmarkFilters.styled';
import {
  OrderOption,
  OrderOptions,
} from '@/features/BookmarkCollections/api/types';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';
import { Portal } from '@/components/UI/Portal/Portal';

interface BookmarkOrderSelectProps {
  isOpen: boolean;
  value: OrderOption;
  onClose: () => void;
  onChange: (option: OrderOption) => void;
}

export const BookmarkOrderSelect = ({
  isOpen,
  value,
  onClose,
  onChange,
}: BookmarkOrderSelectProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useBreakpoint();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  if (!isDesktop) {
    return (
      <Portal>
        <S.SheetWrapper onClick={handleClick}>
          <BottomSheet
            isOpen={isOpen}
            close={onClose}
            isTitleCentered
            onCloseClick={onClose}
            title={t('bookmark_collections.sort_button_title')}
          >
            <S.OrderList>
              <S.OrderListItem
                onClick={() => onChange(OrderOptions.CREATED_AT_DESC)}
              >
                <S.OrderMenuItemText>
                  {t('bookmark_collections.sort_by_publish_date')}
                </S.OrderMenuItemText>
                <S.RadioButton
                  $isActive={value === OrderOptions.CREATED_AT_DESC}
                />
              </S.OrderListItem>
              <S.OrderListItem
                onClick={() => onChange(OrderOptions.PRICE_DESC)}
              >
                <S.OrderMenuItemText>
                  {t('bookmark_collections.sort_by_price_desc')}
                </S.OrderMenuItemText>
                <S.RadioButton $isActive={value === OrderOptions.PRICE_DESC} />
              </S.OrderListItem>
              <S.OrderListItem onClick={() => onChange(OrderOptions.PRICE_ASC)}>
                <S.OrderMenuItemText>
                  {t('bookmark_collections.sort_by_price_asc')}
                </S.OrderMenuItemText>
                <S.RadioButton $isActive={value === OrderOptions.PRICE_ASC} />
              </S.OrderListItem>
            </S.OrderList>
          </BottomSheet>
        </S.SheetWrapper>
      </Portal>
    );
  }

  return (
    <Dropdown isOpen={isOpen} onClose={onClose}>
      <S.OrderMenu>
        <S.OrderMenuItem
          $isActive={value === OrderOptions.CREATED_AT_DESC}
          onClick={() => onChange(OrderOptions.CREATED_AT_DESC)}
        >
          <S.OrderMenuItemText>
            {t('bookmark_collections.sort_by_publish_date')}
          </S.OrderMenuItemText>
          <S.RadioButton $isActive={value === OrderOptions.CREATED_AT_DESC} />
        </S.OrderMenuItem>
        <S.OrderMenuItem
          $isActive={value === OrderOptions.PRICE_DESC}
          onClick={() => onChange(OrderOptions.PRICE_DESC)}
        >
          <S.OrderMenuItemText>
            {t('bookmark_collections.sort_by_price_desc')}
          </S.OrderMenuItemText>
          <S.RadioButton $isActive={value === OrderOptions.PRICE_DESC} />
        </S.OrderMenuItem>
        <S.OrderMenuItem
          $isActive={value === OrderOptions.PRICE_ASC}
          onClick={() => onChange(OrderOptions.PRICE_ASC)}
        >
          <S.OrderMenuItemText>
            {t('bookmark_collections.sort_by_price_asc')}
          </S.OrderMenuItemText>
          <S.RadioButton $isActive={value === OrderOptions.PRICE_ASC} />
        </S.OrderMenuItem>
      </S.OrderMenu>
    </Dropdown>
  );
};
